import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { Collapse, Badge } from "reactstrap";
import SidebarRun from "./Sidebar.run";
import SidebarUserBlock from "./SidebarUserBlock";
import { withNamespaces } from "react-i18next";
import _ from "lodash";
import Authentication from "../../../services/Authentication";
import SessionStorage from "../../../services/SessionStorage";
import { Services } from "../../../repositories/clients/Services";
import axios from "axios";

const auth = new Authentication();
const session = new SessionStorage();

/** Component to display headings on sidebar */
const SidebarItemHeader = ({ item }) => (
  // console.log(item),
  // <li className="nav-heading">
  //   <span>{item.heading}</span>
  // </li>
  <br></br>
);

const SidebarContainer = ({ path, action, children }) => {
  if (action) {
    return (
      <a onClick={action} className="sidebar-container-action">
        {children}
      </a>
    );
  }
  return (
    <Link to={path} className="d-flex align-items-center">
      {children}
    </Link>
  );
};

/** Normal items for the sidebar */
const SidebarItem = ({ t, item, isActive, className }) => (
  <li
    className={isActive ? `active ${className || ""}` : className || ""}
    data-testid="sidebar-item-menu"
  >
    <SidebarContainer path={item.path} action={item.action}>
      {item.label && (
        <Badge tag="div" className="float-right" color={item.label.color}>
          {item.label.value}
        </Badge>
      )}
      {item.icon ? (
        <span className={item.icon + " icons-sidebar"}></span>
      ) : item.img ? (
        <img
          alt=""
          src={item.img}
          height="20"
          width="20"
          style={{ marginLeft: "10px", marginRight: "10px", marginTop: "-3px" }}
        ></img>
      ) : (
        false
      )}
      <span className="label-sidebar">{t(item.name)}</span>
    </SidebarContainer>
  </li>
);

/** Build a sub menu with items inside and attach collapse behavior */
const SidebarSubItem = ({ t, item, isActive, handler, children, isOpen }) => (
  <li className={isActive ? "active" : ""}>
    <div className="nav-item d-flex align-items-center" onClick={handler}>
      {item.label && (
        <Badge tag="div" className="float-right" color={item.label.color}>
          {t(item.label.value)}
        </Badge>
      )}
      {item.icon ? (
        <use
          className={item.icon + " icons-sidebar"}
          style={{ fontSize: " 1.8em" }}
        ></use>
      ) : (
        <img
          // style={{margin: '-6px 6px 1px'}}
          alt=""
          src={item.img}
          height="20"
          width="20"
          style={{ marginLeft: "10px", marginRight: "10px", marginTop: "-3px" }}
        ></img>
      )}
      <span className="label-sidebar">{t(item.name)}</span>
      <i
        className={
          isOpen
            ? "flex fas fa-chevron-up pl-1 pt-1 chevron-custom"
            : "flex fas fa-chevron-down pl-1 pt-1 chevron-custom"
        }
      />
    </div>
    <Collapse isOpen={isOpen}>
      <ul id={item.path} className="sidebar-nav sidebar-subnav">
        {children}
      </ul>
    </Collapse>
  </li>
);

/** Component used to display a header on menu when using collapsed/hover mode */
const SidebarSubHeader = ({ item, t }) => (
  <li className="sidebar-subnav-header">{t(item.name)}</li>
);

class Sidebar extends Component {
  state = {
    collapse: {},
    Menu: this.props._userconfig.Menu.Menu,
  };

  componentDidMount() {
    // pass navigator to access router api
    SidebarRun(this.navigator.bind(this));
    // prepare the flags to handle menu collapsed states
    this.buildCollapseList();
  }

  /** prepare initial state of collapse menus. Doesnt allow same route names */
  buildCollapseList = () => {
    let collapse = {};
    let { Menu } = this.state;
    Menu.filter(({ heading }) => !heading).forEach(
      ({ name, path, submenu }) => {
        collapse[name] = this.routeActive(
          submenu ? submenu.map(({ path }) => path) : path
        );
      }
    );
    this.setState({ collapse });
  };

  navigator(route) {
    this.props.history.push(route);
  }

  routeActive(paths) {
    paths = Array.isArray(paths) ? paths : [paths];
    if (paths.indexOf(this.props.location.pathname.replace("/", "")) > -1)
      return true;
    return false;
  }

  toggleItemCollapse(stateName) {
    for (let c in this.state.collapse) {
      if (this.state.collapse[c] === true && c !== stateName)
        this.setState({ collapse: { [c]: false } });
    }
    this.setState({
      collapse: { [stateName]: !this.state.collapse[stateName] },
    });
  }

  getSubRoutes = (item) => item.submenu.map(({ path }) => path);

  /** map menu config to string to determine what elemetn to render */
  itemType = (item) => {
    if (item.heading) return "heading";
    if (!item.submenu) return "menu";
    if (item.submenu) return "submenu";
  };

  handleLogOut = () => {
    const createOffsetValue = (date) => {
      var sign = date.getTimezoneOffset() > 0 ? "-" : "+";
      var offset = Math.abs(date.getTimezoneOffset());
      var hours = Math.floor(offset / 60);
      var minutes = ((offset % 60) / 60) * 10;
      return sign + hours + "." + minutes;
    };

    let endSession = {
      SessionId: auth.getAuthentication("token"),
      EndConnection: new Date(),
      timezone: createOffsetValue(new Date()),
      Logout: "1",
    };
    axios.post(`${Services.AUDIT.path}user-logs/logout`, endSession);
    /*navigator.sendBeacon(
      `${Services.AUDIT.path}user-logs/logout`,
      JSON.stringify(endSession)
    );*/
  };

  removeToken = () => {
    this.handleLogOut();
    auth.deleteAuthentication("token");
    auth.deleteAuthentication("dataUser");
    auth.deleteAuthentication("customerSelect");
    session.deleteItem("clients");
    session.deleteItem("nit");
    session.deleteItem("lang");
    session.deleteItem("group_list");
    this.props.history.push("/");
  };

  render() {
    let { Menu } = this.state;
    const menuWithoutEmptyObjects = Menu.filter(
      (item) => !_.isPlainObject(item) || !_.isEmpty(item)
    );
    return (
      <aside className="aside-container">
        {/* START Sidebar (left) */}
        <div className="aside-inner">
          <nav data-sidebar-anyclick-close="" className="sidebar">
            {/* START sidebar nav */}
            <ul className="sidebar-nav">
              {/* START user info */}
              <li className="has-user-block">
                <SidebarUserBlock
                  User={this.props._userconfig ? this.props._userconfig : []}
                />
              </li>
              {/* END user info */}

              {/* Iterates over all sidebar items */}
              {menuWithoutEmptyObjects.map((item, i) => {
                // heading
                if (this.itemType(item) === "heading")
                  return (
                    <SidebarItemHeader t={this.props.t} item={item} key={i} />
                  );
                else {
                  if (this.itemType(item) === "menu")
                    return (
                      <SidebarItem
                        t={this.props.t}
                        isActive={this.routeActive(item.path)}
                        item={item}
                        key={i}
                      />
                    );
                  if (this.itemType(item) === "submenu")
                    return [
                      <SidebarSubItem
                        item={item}
                        t={this.props.t}
                        isOpen={this.state.collapse[item.name]}
                        handler={this.toggleItemCollapse.bind(this, item.name)}
                        isActive={this.routeActive(this.getSubRoutes(item))}
                        key={i}
                      >
                        <SidebarSubHeader
                          t={this.props.t}
                          item={item}
                          key={i}
                        />
                        {item.submenu.map((subitem, i) => (
                          <SidebarItem
                            key={i}
                            t={this.props.t}
                            item={subitem}
                            isActive={this.routeActive(subitem.path)}
                          />
                        ))}
                      </SidebarSubItem>,
                    ];
                }
                return null; // unrecognized item
              })}
              <SidebarItem
                t={this.props.t}
                item={{
                  name: "logout",
                  img: "https://whitescreen.dev/images/pro/white-screen_32.png",
                  action: this.removeToken,
                }}
                className="logout_menu_button"
                key={"logout"}
              />
            </ul>
            {/* END sidebar nav */}
          </nav>
        </div>
        {/* END Sidebar (left) */}
      </aside>
    );
  }
}

export default withNamespaces()(withRouter(Sidebar));
